

















































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator';

import { Brand, BrandsService, Monitoring } from '@/api/braendz';
import { BusyObject } from '@/models/Busy';

import TruncateTooltip from '@/components/TruncateTooltip.vue';
import ConfirmationPopup from '@/components/Popups/ConfirmationPopup.vue';
import { generateKey } from 'crypto';

@Component({
    components: {
        TruncateTooltip,
        ConfirmationPopup
    },
    model: {
        prop: "model",
        event: "modelChanged"
    }
})
export default class MonitoringCard extends Vue {
    // Member
    public brand = new BusyObject<Brand>();
        
    // Properties
    @Prop({ required: true })
    public model!: Monitoring;

    // Getter & Setter
    public get fullBrandLogoUrl(): string | null {
        if(!this.brand.object?.brandLogoUrl) {
            return null;
        }
        return this.$braendz.getBrandLogoUrl(this.brand.object);
    }

    public get generatedName(): string | null {
        const brand = this.brand.object;
        if(!brand) return null;

        const office = brand.registrationOfficeCode?.key;
        const number = brand.registrationNumber ?? brand.applicationNumber;

        if(office && number) {
            return `${office}-${number}`;
        }
        return null;
    }

    
    // Watcher:

    // Lifecycle Methods:
    public mounted() {
        this.initBrand();
    }

    // Methods:
    public async initBrand() {
        await this.brand.load(async () => {
            return this.model.brandId ? await BrandsService.getBrand(this.model.brandId) : null;
        });
    }

    public async remove() {
        this.$emit("remove", this.model);
    }
}
